import Cookies from 'js-cookie'
import qs from 'qs'
import { withRouter } from 'react-router-dom'

import { getAllUtmValues } from 'organisms/Intercom/utils'

const storeUtmToCookie = (params) => {
  const utmValues = getAllUtmValues(params)
  Object.keys(utmValues).forEach((key) => {
    const cookieValue = Cookies.get(key)
    if (!cookieValue) {
      Cookies.set(key, utmValues[key], { domain: 'simplesat.io', secure: true })
      Cookies.set(key, utmValues[key], { domain: '.simplesat.io', secure: true })
    }
  })
}

const storeReferrerToCookie = () => {
  const { referrer } = document

  const cookieValue = Cookies.get('referrer')
  if (!cookieValue && referrer) {
    Cookies.set('referrer', referrer, { domain: 'simplesat.io', secure: true })
    Cookies.set('referrer', referrer, { domain: '.simplesat.io', secure: true })
  }
}

export const StoreUtmAndReferrerToCookie = withRouter(({ location }) => {
  const params = qs.parse(location.search, { ignoreQueryPrefix: true })
  storeUtmToCookie(params)
  storeReferrerToCookie()

  return null
})



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/StoreUtmAndReferrerToCookie.js